import { Area as AreaGenerator } from 'd3-shape';
import { motion } from 'framer-motion';
import { useMemo } from 'react';
import { getOpacityFn } from '../styles';
import { spring } from '../transition';

interface LineGraphAreaProps {
    lineId: string | number;
    hoverId: string | number | undefined;
    fill: string;
    points: Record<'x' | 'y', number>[];
    disableAnimation: boolean;
    areaGenerator: AreaGenerator<{
        x: number;
        y: number;
    }>;
}

const getOpacity = getOpacityFn(0.3, 0.05);

/**
 *
 * @returns gradient fill layer when enableArea is selected
 */
export const LineGraphArea: React.FC<LineGraphAreaProps> = ({
    fill,
    lineId,
    hoverId,
    points,
    disableAnimation,
    areaGenerator
}) => {
    const areaPath = useMemo(() => areaGenerator(points), [points, areaGenerator]);

    const opacity = getOpacity(lineId, hoverId);

    return (
        <>
            {disableAnimation ? (
                <path fill={fill} opacity={opacity} d={areaPath ?? ''} strokeWidth={0} pointerEvents='none' />
            ) : (
                <motion.path
                    fill={fill}
                    initial={{ d: areaPath ?? '', opacity }}
                    animate={{
                        opacity,
                        d: areaPath ?? ''
                    }}
                    transition={spring}
                    strokeWidth={0}
                    pointerEvents='none'
                />
            )}
        </>
    );
};
